module.exports = __webpack_public_path__ + "static/media/proposition.e1c5669b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/gpi/form/proposition.pdf
// module id = 853
// module chunks = 40